<template>
  <TimeslotDashboardLayout>
    <div class="main-content">
      <div class="welcome-wrappr">
        <div class="text-block-43">Feeds</div>
      </div>
      <div class="empty-message-container">
        <img src="@/assets/timeslot-images/feeds.svg" width="50" height="50" />
        <div class="new-message">Nothing to show here</div>
        <div class="new-message-sub">
          Appointments with professionals <br />
          would show up here
        </div>
        <router-link
          to="/discover-professionals"
          class="timeslot-button w-button"
          >Discover professionals</router-link
        >
      </div>
      <!--      <div class="feeds-wrapper">-->
      <!--        <div class="div-block-3">-->
      <!--          <div class="feeds-profile-image"></div>-->
      <!--          <div>-->
      <!--            <div class="text-block-44">Seun Orofin</div>-->
      <!--            <div class="text-block-7">-->
      <!--              <a href="#" class="link-2">Product Designer</a>-->
      <!--            </div>-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="header">-->
      <!--          <div class="feeds-caption">-->
      <!--            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit-->
      <!--            tincidunt aliquam justo, orci adipiscing aliquam proin vitae, sit.-->
      <!--            Fringilla adipiscing eget donec in purus neque, arcu, diam,-->
      <!--            dignissim. Iaculis convallis feugiat sed pellentesque duis mauris.-->
      <!--            At massa diam tellus felis mi aenean etiam. Tristique aenean-->
      <!--            ullamcorper tincidunt ante vel.-->
      <!--          </div>-->
      <!--        </div>-->
      <!--        <div class="feeds-footer">-->
      <!--          <div class="feeds-action-wrapper">-->
      <!--            <a href="#" class="feeds-action w-inline-block"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/like.svg"-->
      <!--                loading="lazy"-->
      <!--                id="like-button"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </a>-->
      <!--            <a href="#" class="feeds-action w-inline-block"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/dislike.svg"-->
      <!--                loading="lazy"-->
      <!--                alt=""-->
      <!--              />-->
      <!--              <div class="feeds-action-counter">0</div>-->
      <!--            </a>-->
      <!--            <a-->
      <!--              data-w-id="1f904bd5-198b-ee22-1836-695b7d40e19b"-->
      <!--              href="#"-->
      <!--              class="feeds-action w-inline-block"-->
      <!--              @click="openShare"-->
      <!--              ><img-->
      <!--                src="@/assets/timeslot-images/Group-36577.svg"-->
      <!--                loading="lazy"-->
      <!--                id="myDIV"-->
      <!--                alt=""-->
      <!--            /></a>-->
      <!--          </div>-->
      <!--          <div class="feeds-time-stamp">Posted 2 hours ago</div>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="feeds-wrapper" v-if="share">
        <div class="div-block-3">
          <div class="feeds-profile-image"></div>
          <div>
            <div class="text-block-44">Seun Orofin</div>
            <div class="text-block-7">
              <a href="#" class="link-2">Product Designer</a>
            </div>
          </div>
        </div>
        <div class="header">
          <div class="feeds-caption">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sit
            tincidunt aliquam justo, orci adipiscing aliquam proin vitae, sit.
            Fringilla adipiscing eget donec in purus neque, arcu, diam,
            dignissim. Iaculis convallis feugiat sed pellentesque duis mauris.
            At massa diam tellus felis mi aenean etiam. Tristique aenean
            ullamcorper tincidunt ante vel.
          </div>
          <div class="feeds-media">
            <img
              src="../../../assets/timeslot-images/image-5.png"
              loading="lazy"
              width="675"
              sizes="100vw"
              srcset="
                ../../../assets/timeslot-images/image-5-p-500.png   500w,
                ../../../assets/timeslot-images/image-5-p-800.png   800w,
                ../../../assets/timeslot-images/image-5-p-1080.png 1080w,
                ../../../assets/timeslot-images/image-5.png        1350w
              "
              alt=""
            />
          </div>
        </div>
        <div class="feeds-footer">
          <div class="feeds-action-wrapper">
            <div class="feeds-action">
              <img
                src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d32b5b368620_like.svg"
                loading="lazy"
                id="like-button"
                alt=""
              />
              <div class="feeds-action-counter">0</div>
            </div>
            <div class="feeds-action">
              <img
                src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d36baf36862f_dislike.svg"
                loading="lazy"
                alt=""
              />
              <div class="feeds-action-counter">0</div>
            </div>
            <img
              src="https://uploads-ssl.webflow.com/6299c6ac6dd7d329873685ae/6299c6ac6dd7d3c7f0368621_Group%2036577.svg"
              loading="lazy"
              id="myDIV"
              alt=""
            />
          </div>
          <div class="feeds-time-stamp">Posted 2 hours ago</div>
        </div>
      </div>
    </div>
    <ShareModal v-if="share" :cancel="closeShare" />
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import ShareModal from "@/components/modal/ShareModal";
export default {
  name: "CustomerFeeds",
  components: { ShareModal, TimeslotDashboardLayout },
  data() {
    return {
      share: false
    };
  },
  methods: {
    openShare() {
      this.share = true;
    },
    closeShare() {
      this.share = false;
    }
  }
};
</script>

<style scoped>
.feeds-wrapper-alt {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}
</style>
